import { useCallback, useMemo } from "react"
import { useDeleteConfirm } from "../../../../hooks/useDeleteConfirm"
import { useDeviceCategories } from "../../../../hooks/useDeviceCategories"
import { DimaFeatureShortNameEnum } from "../../../models/Authorization"
import { DeviceCategoryGet } from "../../../models/DeviceCategory"
import { deleteEntity } from "../../../utils/deleteEntity"
import { DiMaAddButton } from "../../partials/DiMaAddButton"
import { EntityRow, EntityTab } from "../../partials/EntityTab"

export function Categories() {
  const { deviceCategoriesList, isLoadingDeviceCategories } = useDeviceCategories()
  const { requestDelete, DeleteConfirmDialog } = useDeleteConfirm()

  const columns = [
    {
      field: "name",
      headerName: "Name",
      isLink: true,
      linkBasePath: "/devices/categories",
    },
  ]

  const sorted = [...deviceCategoriesList].sort((a, b) =>
    (a.name ?? "").localeCompare(b.name ?? "")
  )

  const rows = sorted.map((deviceCategory: DeviceCategoryGet) => ({
    id: deviceCategory.id,
    name: deviceCategory.name,
  }))

  const toolbar = useMemo(
    () => (
      <DiMaAddButton
        url="/devices/categories/create"
        feature={DimaFeatureShortNameEnum.DM}
      />
    ),
    []
  )

  const handleActionMenuClick = useCallback(
    (item: { title: string }, row: EntityRow) => {
      if (item.title === "Delete") {
        requestDelete(() => deleteEntity(`/deviceCategories/${row.id}`))
      }
    },
    [requestDelete]
  )

  return (
    <>
      {DeleteConfirmDialog}
      <EntityTab
        rows={rows}
        cols={columns}
        isLoading={isLoadingDeviceCategories}
        toolbar={toolbar}
        actionItems={[{ title: "Delete", iconName: "icon_abb_dias icon-abb_delete" }]}
        onActionMenuClick={handleActionMenuClick}
      />
    </>
  )
}
